import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import EditorSegments from "./EditorSegments.js";
import Context from "./Context.js";
import EditorRowInfo from "./EditorRowInfo.js";
import EditorParaula from "./EditorParaula";

										
class EditorRow extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		let linia = [];
		linia.push(<Grid item xs={5}><Box borderTop={1}><Context
						iTu = {this.props.iTu}
						iSeg = {this.props.iSeg}
						index = {this.props.indexTotal}
						current={false}
//						original={true}
						accio={this.props.accio}
						tmxMatch={this.props.tmxMatch}
						tagSeleccionat={this.props.current ? this.props.tagSeleccionat : -1}
						isRepetition={this.props.isRepetition}
						isRepetitionSrc={this.props.isRepetitionSrc}
						showInvChars={this.props.showInvChars}
						spellErrors={null}
						handleGotoError={this.props.handleGotoError}
						firstSpellErrorIndex={this.props.firstSpellErrorIndex}
						segment={this.props.segment["src"]}
						//glossary={this.props.glossary}
					/></Box></Grid>)
		//let color = this.props.segment["trg"]["state"]==="new" ? "#94C1DA" : "#94da9b" ;
		let color ="#94DA9B";
		if(this.props.segment["trg"]["state"]==="new"){
			color="#94C1DA";
		}else if(this.props.segment["trg"]["state"]==="blocked"){
			color="#FF937E";
		}
		linia.push(<Grid item xs={1}><Box bgcolor={color} borderTop={1}>
						<EditorRowInfo
							index = {this.props.indexTotal}
							count = {this.props.count}
							current={this.props.current}
							tmxMatch={this.props.tmxMatch}
							tmxDistance={this.props.tmxDistance}
							segment={this.props.segment}
							isRepetition={this.props.isRepetition}
							isRepetitionSrc={this.props.isRepetitionSrc}
							handleGotoSegment={this.props.handleGotoSegment}
							traspassaSegment={this.props.traspassaSegment}
							desbloquejaSegment={this.props.desbloquejaSegment}
						/>
					</Box></Grid>);

		if(this.props.current){
			if(this.props.segment["trg"]["state"]==="blocked"){
				linia.push(<Grid item xs={6}><Box borderTop={1}><Context
							iTu = {this.props.iTu}
							iSeg = {this.props.iSeg}
							index = {this.props.indexTotal}
							current={false}
//							original={true}
							accio={this.props.accio}
							tmxMatch={this.props.tmxMatch}
							tagSeleccionat={this.props.tagSeleccionat}
							isRepetition={this.props.isRepetition}
							isRepetitionSrc={this.props.isRepetitionSrc}
							showInvChars={this.props.showInvChars}
							spellErrors={this.props.spellErrors}
							handleGotoError={this.props.handleGotoError}
							firstSpellErrorIndex={this.props.firstSpellErrorIndex}
							segment={this.props.segment["trg"]}
							//glossary={this.props.glossary}
				/></Box></Grid>)
			}else{
				if(this.props.spellErrors==null){
					linia.push(<Grid item xs={6}><Box borderTop={1}><EditorSegments
								iTu = {this.props.iTu}
								iSeg = {this.props.iSeg}
								index = {this.props.indexTotal}
								current={true}
								handleNext={this.props.handleNext}
								updateSegment={this.props.updateSegment}
								onSeleccionaTag={this.props.onSeleccionaTag}
								segment={this.props.segment}
								simplificaTags={false}
								showInvChars={this.props.showInvChars}
								tmxMatch={this.props.tmxMatch}
								validaSegment={this.props.validaSegment}
								//glossary={this.props.glossary}
							/></Box></Grid>)
				}else{
					if(this.props.editantParaula){
						linia.push(<Grid item xs={6}><Box bgcolor="#d6eaf8" borderTop={1}><EditorParaula
									handleNext={this.props.handleNext}
									updateSpellError={this.props.updateSpellError}
									segment={this.props.segment}
									current={true}
									spellErrors={this.props.spellErrors}
									currentSpellError={this.props.currentSpellError}
									showInvChars={this.props.showInvChars}
									handleGotoError={this.props.handleGotoError}
									firstSpellErrorIndex={this.props.firstSpellErrorIndex}
								/></Box></Grid>)
					}else{
						linia.push(<Grid item xs={6}><Box borderTop={1}><Context
							iTu = {this.props.iTu}
							iSeg = {this.props.iSeg}
							index = {this.props.indexTotal}
							current={false}
//							original={true}
							accio={this.props.accio}
							tmxMatch={this.props.tmxMatch}
							tagSeleccionat={this.props.tagSeleccionat}
							isRepetition={this.props.isRepetition}
							isRepetitionSrc={this.props.isRepetitionSrc}
							showInvChars={this.props.showInvChars}
							spellErrors={this.props.spellErrors}
							handleGotoError={this.props.handleGotoError}
							firstSpellErrorIndex={this.props.firstSpellErrorIndex}
							segment={this.props.segment["trg"]}
							//glossary={this.props.glossary}
						/></Box></Grid>)
					}
				}
			}
		}else{
			linia.push(<Grid item xs={6}><Box borderTop={1}><Context
						iTu = {this.props.iTu}
						iSeg = {this.props.iSeg}
						index = {this.props.indexTotal}
						current={false}
//						original={true}
						accio={this.props.accio}
						tmxMatch={this.props.tmxMatch}
						tagSeleccionat={-1}
						isRepetition={this.props.isRepetition}
						isRepetitionSrc={this.props.isRepetitionSrc}
						showInvChars={this.props.showInvChars}
						spellErrors={this.props.spellErrors}
						segment={this.props.segment["trg"]}
						handleGotoError={this.props.handleGotoError}
						firstSpellErrorIndex={this.props.firstSpellErrorIndex}
						//glossary={this.props.glossary}
					/></Box></Grid>)
		}
		return(<Grid container direction="row" justify="center" alignItems="flex-start" xs={12} spacing={0}>{linia}</Grid>);
//		return({linia})
	}
}

export default EditorRow;